import React from 'react';
import queryString from 'query-string';
import moment from 'moment';
import FlowCard from "../../../../../../CommonComponents/FlowCard/FlowCard";
import formatter from '../../../../../../utils/formatter';
import { GridDiv, FlexContainer, PageHeading } from './styles';
import { Col } from 'antd';
import { ScheduleType as ScheduleTypeConstants, ExchangeType as ExchangeTypeConstants } from '../../constants';
import { Heading, SectionHeading } from '../../styles';
import {
    DataHeading
} from "../../../../../../CommonComponents/commonStyles";
import { CustomizedFlowCard } from '../exchangeReview/styles';
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import { CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';

const ExchangeOptions = (props) => {
    const { edit, scheduleType, exchangeType, total, location, history, id, tradeDate, isNew, isViewEdit, status } = props;
    const renderFixGrid = ({ gridName, value }) => {
        return (
            <>
                <DataHeading className='mb-5'>{gridName}</DataHeading>
                <Heading>{value}</Heading>
            </>
        )
    };

    const cardConfig = [
        {
            name: 'scheduleType',
            gridWidth: '50',
            type: 'FixGrid',
            className: 'grid-with-border',
            render: renderFixGrid({
                gridName: 'Schedule Type:',
                value: scheduleType === ScheduleTypeConstants.onetime ?
                    'One-time Exchange'
                    : scheduleType === ScheduleTypeConstants.recurring ?
                        'Recurring Exchange'
                        : scheduleType === ScheduleTypeConstants.tiff ?
                            'TIFF Exchange'
                            : ''
            }),
            pbottom: true,
        },
        {
            name: 'exchangeType',
            gridWidth: '50',
            type: 'FixGrid',
            className: 'grid-with-border',
            render: renderFixGrid({
                gridName: 'Exchange Type:',
                value: exchangeType === ExchangeTypeConstants.custom ?
                    'Custom Exchange'
                    : exchangeType === ExchangeTypeConstants.reallocation ?
                        'Reallocation Exchange'
                        : exchangeType === ExchangeTypeConstants.fromTIFF ?
                            'Exchange from TIFF'
                            : exchangeType === ExchangeTypeConstants.intoTIFF ?
                                'Exchange into TIFF'
                                : ''
            }),
            pbottom: true,
        },
    ];
    if (isViewEdit && !isNew && status === 'Completed') {
    } else {
        total && cardConfig.push({
            name: 'total',
            gridWidth: '50',
            type: 'FixGrid',
            className: 'grid-with-border',
            render: renderFixGrid({
                gridName: 'Total estimated exchange amount:',
                value: Boolean(Number(total)) ? formatter({ value: total, fieldSuffix: 'Dollars' }) : '$0.00'
            }),
            ptop: true,
        });
    }

    const styleConfig = {
        cardBorder: false,
    };
    return (
        <Col span={24} md={11}>
            <FlexContainer>
                <SectionHeading>Exchange Summary</SectionHeading>
                {edit && isNew && <CapsuleButton iconType="edit" text="Edit" id="btnEditExchange" onClick={(e) => {
                    try {
                        let params = queryString.parse(location.search);
                        const scheduleTypeLabel = scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                        if(Object.keys(params).length > 0) {
                            initiateTracking('edit', 'View and Edit Exchange', 'Exchange Summary', `Edit - ${scheduleTypeLabel}`);
                        } else {
                            initiateTracking('edit', 'Recommend An Exchange', 'Step 3 Review exchange and submit - Exchange Summary', `Edit - ${scheduleTypeLabel} - Body`);
                        }
                        params = params ? { ...params, edit: true } : { edit: true }
                        history.push({
                            pathname: `/investments/recommend-an-exchange/${id}/from`,
                            search: queryString.stringify(params)
                        });
                    } catch (error) {
                        recordError(error);
                    }
                }} />}
            </FlexContainer>
            <CustomizedFlowCard total={total}>
                <FlowCard
                    cardConfig={cardConfig}
                    styleConfig={styleConfig}
                />
            </CustomizedFlowCard>
        </Col>
    );
};

export default ExchangeOptions;